import { useMemo } from 'react';
import type { ObjectSchema } from 'yup';
import { isFieldRequired } from '../helpers/form';

export function useFieldsValidation(
  schema: ObjectSchema<any>,
  fieldNames: string[],
) {
  return useMemo(() => {
    const requiredFields: Record<string, boolean> = {};
    fieldNames.forEach((fieldName) => {
      requiredFields[fieldName] = isFieldRequired(schema, fieldName);
    });
    return {
      requiredFields,
      isRequired: (fieldName: string) => requiredFields[fieldName] || false,
      schema,
    };
  }, [schema, fieldNames]);
}
